query getSavedDesignById($id: ID!) {
	viewer {
		id
		savedDesignById(id: $id) {
			# ...savedDesignProject fragment. Couldn't work out how to get fragments working 
			# on client though
			id
			sourceImageKey
			sourceImageUrl
			backgroundMaskImageUrl
			colorisationImageUrl
			enhanceFacesImageUrl
			posteriseImage {
				type
				url
				message
			}
			mediumImageUrl
			faceBoundingBoxes {
				x
				y
				width
				height
			}
			currentPicture {
				# ...pictureConfigurationOutput fragment, but couldn't get working with client
				updatedAt

				imageZoom
				imageZoomOffset {
					x
					y
				}

				basePlateSize
				numberOfBasePlates {
					width
					height
				}

				brightness
				contrast
				saturation

				detailFilter {
					strength
					radiusRatio
				}
				dithering {
					serpentine
					clamp
					strength
				}

				removeBackground {
					newColour
				}
				enhanceFaces
				fixFaceColours
				posterise

				paletteMode {
					type
					numberOfColours
					palette
				}

				pen {
					type
					value
				}
				buildNumberOfColours
			}
			otherVersions {
				# ...pictureConfigurationOutput fragment, but couldn't get working with client
				updatedAt

				imageZoom
				imageZoomOffset {
					x
					y
				}

				basePlateSize
				numberOfBasePlates {
					width
					height
				}

				brightness
				contrast
				saturation

				detailFilter {
					strength
					radiusRatio
				}
				dithering {
					serpentine
					clamp
					strength
				}

				removeBackground {
					newColour
				}
				enhanceFaces
				fixFaceColours
				posterise

				paletteMode {
					type
					numberOfColours
					palette
				}

				pen {
					type
					value
				}
			}
			updatedAt
			whoFor
			giftType
		}
	}
}